export const returnData = {
  configuration: {
    rawData: "Rückgabe ohne Wrapper"
  },
  input: {
    returnData: "Rückgabewert"
  }
};
